import * as preRegisterApi from '../api/pre-register'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const FETCH_PREGISTERED_EMAILS = 'FETCH_PREGISTERED_EMAILS'

export const fetchPregisteredEmails = () => (dispatch) => {
    preRegisterApi
        .listObj()
        .then((data) => {
            dispatch({
                type: FETCH_PREGISTERED_EMAILS,
                payload: data,
            })
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const pregisterEmail = (email) => (dispatch) => {
    preRegisterApi
        .putObj(email.toLowerCase())
        .then(() => {
            dispatch(fetchPregisteredEmails())
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const pregisterEmailList = (emailList) => (dispatch) => {
    preRegisterApi
        .putList(emailList)
        .then(() => {
            dispatch(fetchPregisteredEmails())
        })
        .then(() => dispatch(showSuccess("Email(s) pre-registered!")))
        .catch((err) => dispatch(handleApiError(err)))
}

export const unPregisterEmail = (email) => (dispatch) => {
    preRegisterApi
        .deleteObj(email)
        .then(() => {
            dispatch(fetchPregisteredEmails())
        })
        .catch((err) => dispatch(handleApiError(err)))
}
